import Tag from './Tag'
import CheckableTag from './CheckableTag'

Tag.CheckableTag = CheckableTag
export default Tag




// WEBPACK FOOTER //
// ./components/tag/index.js